import {getAuthToken,clearAuthSession} from '../auth.js';
import {db} from '../db.js';
import {readApiResponse} from '../apiResponse.js';
import {GuestApiError} from '../guestApi.js';
import type {UploadStatus,UploadTransport} from './uploadTypes.js';

async function request(path:string,method:string,body:unknown,signal:AbortSignal):Promise<UploadStatus>{
 const database=db,token=getAuthToken(),runtimeBase=(window as any).process?.env?.VITE_API_URL;
 const base=runtimeBase&&!runtimeBase.startsWith('__')?runtimeBase:import.meta.env.VITE_API_URL||'';
 const binary=body instanceof Blob;
 // Safari's network process can fail to read disk-backed IndexedDB Blobs.
 // Materialize only this bounded chunk; keep the retained original unchanged.
 const payload=body===undefined?undefined:binary?await body.arrayBuffer():JSON.stringify(body);
 if(database!==db||token!==getAuthToken())throw new Error('Account changed. The original remains in its account.');
 signal.throwIfAborted();
 const response=await fetch(`${base}/api/photo-uploads${path}`,{method,headers:{Authorization:`Bearer ${token}`,'Content-Type':binary?'application/octet-stream':'application/json'},
  body:payload,signal:AbortSignal.any([signal,AbortSignal.timeout(30000)])});
 if(database!==db||token!==getAuthToken())throw new Error('Account changed. The original remains in its account.');
 const data=await readApiResponse(response);
 if(database!==db||token!==getAuthToken())throw new Error('Account changed. The original remains in its account.');
 if(response.status===401&&token)clearAuthSession();
 if(!response.ok)throw new GuestApiError(data.error||'Photo upload unavailable.',response.status);
 return data;
}
export const photoUploadTransport:UploadTransport={
 start:(manifest,signal)=>request('','POST',manifest,signal),status:(id,signal)=>request('/'+encodeURIComponent(id),'GET',undefined,signal),
 chunk:(id,offset,bytes,signal)=>request('/'+encodeURIComponent(id)+'/chunk?offset='+offset,'PUT',bytes,signal),
 finish:(id,signal)=>request('/'+encodeURIComponent(id)+'/finish','POST',{},signal),cancel:(id,signal)=>request('/'+encodeURIComponent(id),'DELETE',undefined,signal),
};
